module.exports = __webpack_public_path__ + "media/Hi-Hat.56cebe94.wav";